import { cases } from '@/mocks/cases';

const caseImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Smart%20city%20technology%20infrastructure%20with%20modern%20buildings%20and%20digital%20connections%20in%20Southeast%20Asian%20city%20warm%20golden%20hour%20lighting&width=400&height=320&seq=case-img-1&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Solar%20panel%20farm%20in%20desert%20landscape%20with%20modern%20energy%20infrastructure%20warm%20sunset%20lighting%20professional%20photography&width=400&height=320&seq=case-img-2&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Premium%20consumer%20product%20display%20in%20international%20retail%20setting%20with%20elegant%20branding%20elements%20warm%20sophisticated%20lighting&width=400&height=320&seq=case-img-3&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Digital%20commerce%20dashboard%20with%20multiple%20platform%20metrics%20on%20screens%20modern%20tech%20office%20setting%20warm%20professional%20lighting&width=400&height=320&seq=case-img-4&orientation=landscape',
};

export default function Cases() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold tracking-widest uppercase text-primary-500 mb-3 block">客户案例</span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            助力企业征战全球
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto leading-relaxed">
            每一个成功案例，都是征途国际专业实力的最好见证
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {cases.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100/70 border border-background-200/60 rounded-lg overflow-hidden flex flex-col md:flex-row"
            >
              <div className="w-full md:w-48 h-40 md:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={caseImages[item.id]}
                  alt={item.company}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 p-5 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 flex-wrap mb-2">
                    <span className="text-xs px-2 py-0.5 bg-accent-100/80 text-accent-700 rounded-full font-medium">
                      {item.service}
                    </span>
                    <span className="text-xs text-foreground-400">{item.industry}</span>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2 font-heading">{item.company}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}